import { AA_BLUE, COOL_GRAY_3, COOL_GRAY_5, DARK_BLUE, ELECTRIC_BLUE, MIST_BLUE, WHITE } from '../../constants'
import { defaultThemeBreakpoints } from '../defaultThemeBreakpints'

import { NavbarTheme } from './types'

export default {
  ...defaultThemeBreakpoints,
  baseElementSize: 16,
  name: 'transparent',
  nav: {
    background: 'transparent',
    mobileBackground: WHITE,
    text: WHITE,
  },
  hamburgerButton: {
    background: WHITE,
  },
  subItems: {
    background: WHITE,
    title: DARK_BLUE,
    description: COOL_GRAY_3,
    icon: {
      fill: ELECTRIC_BLUE,
      bg: MIST_BLUE,
      bgHover: `${ELECTRIC_BLUE}29`,
    },
    separator: COOL_GRAY_5,
  },
  signIn: {
    textMobile: AA_BLUE,
    text: WHITE,
    bg: 'transparent',
    bgHover: 'transparent',
  },
  signOut: {
    text: AA_BLUE,
  },
} as NavbarTheme
